class PromoCampaignsElement extends HTMLElement {
  connectedCallback() {
    this.abortController = null;
    this.renderMounts();
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.abortController) this.abortController.abort();
  }

  renderMounts() {
    this.renderSource('product', '[data-promo-campaigns-product-mount]');
    this.renderSource('cart', '[data-promo-campaigns-cart-drawer-mount]');
    this.renderSource('cart', '[data-promo-campaigns-cart-page-mount]');
  }

  renderSource(sourceName, mountSelector) {
    const source = this.querySelector(`template[data-promo-source="${sourceName}"]`);
    document.querySelectorAll(mountSelector).forEach((mount) => {
      mount.replaceChildren(...(source ? [...source.content.children].map((child) => child.cloneNode(true)) : []));
      mount.hidden = mount.childElementCount === 0;
    });
  }

  async refresh() {
    if (this.abortController) this.abortController.abort();
    const controller = new AbortController();
    this.abortController = controller;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        signal: controller.signal,
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(`Promo section refresh failed: ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = documentFragment.querySelector('promo-campaigns');
      if (!replacement) throw new Error('Promo section response missing');
      if (this.abortController !== controller) return;

      this.replaceWith(replacement);
    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    }
  }
}

if (!customElements.get('promo-campaigns')) {
  customElements.define('promo-campaigns', PromoCampaignsElement);
}
